import React from 'react';

// Components
import Page from '../Page';
import injectSheet from 'react-jss';

const styles = (theme: any) => {
  return {
    root: {
      maxWidth: theme.widths.content,
      '& h2': {
        textAlign: 'center',
        marginBottom: theme.spacing.unit * 3,
        textDecoration: 'underline',
      },
      '& h3': {
        marginBottom: theme.spacing.unit * 2,
      },
      '& p': {
        marginBottom: theme.spacing.unit * 4,
      },
    },
  };
};

interface Props {
  children: React.ReactNode;
  classes: any;
}

function Cookies({ children, classes }: Props) {
  return <Page classes={{ children: classes.root }}>{children}</Page>;
}

export default injectSheet(styles)(Cookies);
